import { render, staticRenderFns } from "./notifications-dropdown.vue?vue&type=template&id=5c65e1a6&scoped=true&"
import script from "./notifications-dropdown.vue?vue&type=script&lang=ts&"
export * from "./notifications-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./notifications-dropdown.vue?vue&type=style&index=0&id=5c65e1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65e1a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
